import { useTranslation } from 'react-i18next';

const searchFilters = () => {
	const { t } = useTranslation();

	return [
		{
			key: 'GENERAL',
			label: t('search_filter.GENERAL'),
		},
		{
			key: 'PLOT_NUMBER',
			label: t('search_filter.PLOT_NUMBER'),
		},
	];
};

export default searchFilters;
